import React, { useState, useContext, useEffect } from "react";
import axios from 'axios';
import { Accordion, AccordionSummary, AccordionDetails, Button, MenuItem, Select, FormControl, InputLabel, IconButton, Checkbox, TextField, Badge, Popover, Typography, InputAdornment } from "@mui/material";
import { 
    Table, 
    TableBody, 
    TableCell, 
    TableContainer, 
    TableHead, 
    TableRow, 
    Paper 
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NotificationsIcon from '@mui/icons-material/Notifications';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import "./Subscriptions.css";
import "../App.css";
import { TableContext } from '../context';
import { toast } from "react-toastify";
import Loader from './Loader';

const NotificationCenter = () => {

    const [sortOrder, setSortOrder] = useState("Newest First");
    const [statusFilter, setStatusFilter] = useState("All");
    const [filterBy, setFilterBy] = useState("Application");
    const [searchQuery, setSearchQuery] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const { notifications, setNotifications } = useContext(TableContext);
    const [isSelectClicked, setIsSelectClicked] = useState(false);
    const [selectedNotifications, setSelectedNotifications] = useState([]);
    const { tokenFetched, graphData, notificationsLoading, setNotificationsLoading, getNotifications,getToken } = useContext(TableContext);

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleFilterClose = () => {
        setAnchorEl(null);
    };

    const handleAccordionChange = async (notification_id) => {
        setNotifications((prevNotifications) =>
            prevNotifications.map((notification) =>
                notification.notification_id === notification_id ? { ...notification, seen: "true" } : notification
            )
        );
        const notification = notifications.find(notification => notification.notification_id === notification_id);
        if(notification?.seen !== "true") {
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_BACKEND_URI}/api/subscription/updateNotification`,
                    {
                        user_email: graphData?.mail,
                        notification_id: notification_id,
                        notification_status: "true"
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("jwt_token"),
                        }
                    }
                );
                
                if (response.status === 200) {
                    console.log("Notification read status updated successfully for notification_id: ", notification_id);
                } else {
                    console.error('Failed to update notification read status');
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    // useEffect(() => {
    //     if (tokenFetched) {
    //         getNotifications();
    //     }
    // }, [tokenFetched]);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const filteredNotifications = notifications
        .filter((notification) => {
            const matchesSearchQuery = (filterBy === "Application" && notification.app_name?.toLowerCase().includes(searchQuery.trim().toLowerCase())) || (filterBy === "Change Number" && notification.change_number?.toLowerCase().includes(searchQuery.trim().toLowerCase()));
            const matchesStatusFilter = statusFilter === "All" || 
                            (statusFilter === "Unread" && (notification.seen === "false" || notification.seen === "email")) || 
                            notification.seen === statusFilter.toLowerCase();
            return matchesSearchQuery && matchesStatusFilter;
        })
        .sort((a, b) => {
            const dateA = new Date(a.created_at);
            const dateB = new Date(b.created_at);
            return sortOrder === "Newest First" ? dateB - dateA : dateA - dateB;
        });

    const handleSelectClick = () => {
        setIsSelectClicked(true);
    };

    const handleCancel = () => {
        setIsSelectClicked(false);
        setSelectedNotifications([]);
    };

    const handleSelectAllUnread = () => {
        if (selectedNotifications.length === filteredNotifications.filter(notification => notification.seen !== "true").length) {
            setSelectedNotifications([]);
        } else {
            setSelectedNotifications(filteredNotifications.filter(notification => notification.seen !== "true").map(notification => notification.notification_id));
        }
    };

    const handleMarkAsRead = () => {
        setNotifications((prevNotifications) =>
            prevNotifications.map((notification) =>
                selectedNotifications.includes(notification.notification_id) ? { ...notification, seen: "true" } : notification
            )
        );
        handleCancel();
        selectedNotifications.forEach(async (notification_id) => {
            const notification = notifications.find(notification => notification.notification_id === notification_id);
            if(notification?.seen !== "true") {
                try {
                    const response = await axios.post(
                        `${process.env.REACT_APP_BACKEND_URI}/api/subscription/updateNotification`,
                        {
                            user_email: graphData?.mail,
                            notification_id: notification_id,
                            notification_status: "true"
                        },
                        {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem("jwt_token"),
                            }
                        }
                    );
                    
                    if (response.status === 200) {
                        console.log("Notification read status updated successfully for notification_id: ", notification_id);
                    } else {
                        console.error('Failed to update notification read status');
                    }
                } catch (error) {
                    console.error(error);
                }
            }
        });
    };

    const handleCheckboxChange = (notification_id) => {
        setSelectedNotifications((prevSelected) =>
            prevSelected.includes(notification_id)
                ? prevSelected.filter((id) => id !== notification_id)
                : [...prevSelected, notification_id]
        );
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
    
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    return (
        <div>
            <h2>Subscription Notifications</h2>

            {/* Dropdowns */}
            <div className="dropdowns">
                <FormControl className="dropdown" style={{ marginRight: "10px", minWidth: "150px" }}>
                    <Select
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}
                        style={{ height: "40px" }}
                    >
                        <MenuItem value="Newest First">Newest First</MenuItem>
                        <MenuItem value="Oldest First">Oldest First</MenuItem>
                    </Select>
                </FormControl>

                <FormControl className="dropdown" style={{ marginRight: "10px", width: "150px" }}>
                    <Select
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                        style={{ height: "40px" }}
                    >
                        <MenuItem value="All">All</MenuItem>
                        <MenuItem value="true">Read</MenuItem>
                        <MenuItem value="Unread">Unread</MenuItem>
                    </Select>
                </FormControl>

                <Badge badgeContent={searchQuery ? 1 : 0} color="primary">
                    <Button style={{color: "#42b0d5"}} onClick={handleFilterClick}>
                        <FilterListIcon />
                        <Typography variant="caption" style={{ marginLeft: "5px" }}>FILTER</Typography>
                    </Button>
                </Badge>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleFilterClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <div style={{ padding: "10px", display: "flex", flexDirection: "column", position: "relative" }}>
                        {/* <IconButton
                            style={{ position: "absolute", top: "5px", right: "5px" }}
                            onClick={handleFilterClose}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton> */}
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography variant="subtitle1" style={{ width: "45%" }}>Filter By</Typography>
                            <Typography variant="subtitle1" style={{ width: "45%" }}>Value</Typography>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "5px", overflow: "hidden", marginBottom: "5px" }}>
                        <Select
                            value={filterBy}
                            onChange={(e) => setFilterBy(e.target.value)}
                            style={{ height: "30px", width: "45%" }}
                        >
                            <MenuItem value="Application">Application</MenuItem>
                            <MenuItem value="Change Number">Change Number</MenuItem>
                        </Select>
                            <TextField
                                variant="outlined"
                                placeholder="Filter Value"
                                value={searchQuery}
                                onChange={handleSearchChange}
                                style={{ width: "45%" }}
                                InputProps={{
                                    style: {
                                        height: "30px",
                                        padding: '0px'
                                    },
                                    endAdornment: searchQuery && (
                                        <InputAdornment position="end">
                                            <IconButton onClick={() => setSearchQuery('')}>
                                                <ClearIcon fontSize="small"/>
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </div>
                    </div>
                </Popover>

                <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                    {isSelectClicked ? (
                        <>
                            <Button variant="text" style={{ minWidth: "100px", marginRight: "10px", color: "#42b0d5" }} onClick={handleSelectAllUnread}>
                                {selectedNotifications.length === filteredNotifications.filter(notification => notification.seen !== "true").length ? 'Deselect All' : 'Select All Unread'}
                            </Button>
                            <Button variant="contained" style={{ minWidth: "100px", marginRight: "10px", backgroundColor: selectedNotifications.length !== 0 && "#42b0d5" }} onClick={handleMarkAsRead} disabled={selectedNotifications.length === 0}>Mark as Read</Button>
                            <Button variant="text" style={{ minWidth: "100px", color: "#42b0d5" }} onClick={handleCancel}>Cancel</Button>
                        </>
                    ) : (
                        <Button variant="text" className="select-btn" style={{ minWidth: "100px", color: "#42b0d5" }} onClick={handleSelectClick}>Select</Button>
                    )}
                </div>
            </div>

            {notificationsLoading ? ( 
                <Loader />
            ):(
                <div className="table-container">
                    {/* Notifications List */}
                    <div className="notifications-list" style={{marginBottom: "10vh"}}>
                        {filteredNotifications.length > 0 ? (
                        filteredNotifications.map((notification) => (
                            <div className= "notification-item" key={notification.notification_id}>
                            <Accordion key={notification.notification_id} style={{boxShadow: "none", backgroundColor: "transparent"}} onChange={() => handleAccordionChange(notification.notification_id)}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <div className="notification-row">
                                        {isSelectClicked ? (
                                            notification?.seen !== "true" ? (
                                            <Checkbox
                                                checked={selectedNotifications.includes(notification.notification_id)}
                                                onClick={(event) => event.stopPropagation()}
                                                onChange={(event) => {
                                                    event.stopPropagation();
                                                    handleCheckboxChange(notification.notification_id);
                                                }}
                                            />):(
                                                <div style={{ width: "42px" }}></div>
                                            )
                                        ) : (
                                            <FiberManualRecordIcon 
                                                style={{ 
                                                    color: (notification.seen !== "true")?"#42b0d5":"transparent", 
                                                    marginRight: "8px", 
                                                    fontSize: "small" 
                                                    }} 
                                            />
                                        )}
                                        <IconButton aria-label="notification">
                                            <NotificationsIcon />
                                        </IconButton>
                                        <div className="notification-content">
                                            <strong>{notification.app_name}</strong>
                                            <p>Change {notification.change_number} is in {notification.change_state} State</p>
                                        </div>
                                        <div className="notification-date">
                                            {formatDate(notification.created_at)}
                                        </div>
                                    </div>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead style={{ backgroundColor: "#42b0d5" }}>
                                                <TableRow>
                                                    <TableCell style={{ color: "white", textAlign: "center" }}>Created At</TableCell>
                                                    <TableCell style={{ color: "white", textAlign: "center" }}>Change Number</TableCell>
                                                    <TableCell style={{ color: "white", textAlign: "center" }}>Configuration Item</TableCell>
                                                    <TableCell style={{ color: "white", textAlign: "center" }}>Risk</TableCell>
                                                    <TableCell style={{ color: "white", textAlign: "center" }}>Planned Start Date</TableCell>
                                                    <TableCell style={{ color: "white", textAlign: "center" }}>Planned End Date</TableCell>
                                                    <TableCell style={{ color: "white", textAlign: "center" }}>State</TableCell>
                                                    <TableCell style={{ color: "white", textAlign: "center" }}>Relationship</TableCell>
                                                    <TableCell style={{ color: "white", textAlign: "center" }}>Assignment Group</TableCell>
                                                    <TableCell style={{ color: "white", textAlign: "center" }}>Requested By</TableCell>
                                                    <TableCell style={{ color: "white", textAlign: "center" }}>Outage Start</TableCell>
                                                    <TableCell style={{ color: "white", textAlign: "center" }}>Outage End</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell style={{ textAlign: "center" }}>{notification.created_at ? formatDate(notification.created_at) : "NA"}</TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>
                                                        {/^CHG/.test(notification?.change_number) ? (
                                                            <a 
                                                                href={`https://maersk.service-now.com/nav_to.do?uri=change_request.do?sysparm_query=number=${notification.change_number}`} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer"
                                                                style={{ color: "#42b0d5", textDecoration: "none" }}
                                                            >
                                                                {notification?.change_number}
                                                            </a>
                                                        ) : (notification?.change_number)}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>{notification?.configuration_item}</TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>{notification?.risk_impact}</TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>{notification?.planned_start_date ? formatDate(notification.planned_start_date) : "NA"}</TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>{notification.planned_end_date ? formatDate(notification.planned_end_date) : "NA"}</TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>{notification.change_state}</TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>{notification?.relationship}</TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>{notification?.assignment_group}</TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>{notification?.requested_by}</TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>{notification.outage_start ? formatDate(notification.outage_start) : "NA"}</TableCell>
                                                    <TableCell style={{ textAlign: "center" }}>{notification.outage_end ? formatDate(notification.outage_end) : "NA"}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </AccordionDetails>

                            </Accordion>
                            </div>
                        ))) : (
                            <div style={{ textAlign: 'center', margin: '20px' }}>
                                <p>No notifications available.</p>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default NotificationCenter;